import React, { Suspense, lazy } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import history from '../services/utils/history'
import configureStore from '../store/configure-store'

const ScanAndGo = lazy(() => import('../scenes/scan-and-go'))
const WebApp = lazy(() => import('../components/web-app'))


const Routes = () => (
  <Provider store={configureStore()}>
    <Router history={history}>
      <Suspense fallback={<div>&nbsp;</div>}>
        <Switch>
          <Route path="/sng_kiosk" component={ScanAndGo} />
          <Route path="/" component={WebApp} />
        </Switch>
      </Suspense>
    </Router>
  </Provider>
)

export default Routes
